import { type JSX } from "react";
import { PersonalAccessTokenScope } from "common";
import { classNames } from "@via/utils/helpers.tsx";

/** The words for each access level, shared by the create form, the list and the display modal. */
export const ACCESS_SCOPE_LABELS: Record<PersonalAccessTokenScope, string> = {
  [PersonalAccessTokenScope.Read]: "Read",
  [PersonalAccessTokenScope.Write]: "Write",
  [PersonalAccessTokenScope.Admin]: "Admin",
};

const STYLES: Record<PersonalAccessTokenScope, string> = {
  [PersonalAccessTokenScope.Read]: "text-gray-700 ring-gray-300",
  [PersonalAccessTokenScope.Write]: "text-indigo-700 ring-indigo-200",
  [PersonalAccessTokenScope.Admin]: "text-amber-700 ring-amber-300",
};

export const FULL_ACCESS_TITLE =
  "Created before access levels existed. Delete it and create a new one to limit what it can do.";

/**
 * A personal access token's access level (sec-4-16). null is a token created before access levels
 * existed, which keeps full access.
 */
const AccessScopeBadge = ({
  scope,
}: {
  scope: PersonalAccessTokenScope | null;
}): JSX.Element => {
  const base =
    "inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset";
  if (scope === null) {
    return (
      <span
        title={FULL_ACCESS_TITLE}
        className={classNames(base, "text-red-700 ring-red-300")}>
        Full access
      </span>
    );
  }
  return (
    <span className={classNames(base, STYLES[scope])}>
      {ACCESS_SCOPE_LABELS[scope]}
    </span>
  );
};

export default AccessScopeBadge;
